export const slideShowWithContent = (arr) => {
    let arrIndex = [];
    arr.forEach((e, i) => arrIndex.push(parseInt(i)));
    let index = 0;
    let tempTotal = 2;

    const slideShow = () => {
        let temp = [];
        arrIndex.forEach(e => {
            arr[e].classList.remove('active')
            if (temp.length <= tempTotal) {
                temp.push(arrIndex[index]);
                index <= arrIndex.length - tempTotal ? index++ : index = 0;
            }
        })
        index = arrIndex.indexOf(temp[1]);
        temp.forEach(e => arr[arrIndex[e]].classList.add('active'));
    }

    setTimeout(() => {
        slideShow();
    }, 800)

    setInterval(() => {
        slideShow();
    }, 2000)
}
